<template>
  <div class="w-32 flex ml-2 justify-end">
    <transition :name="'fade'">
      <vs-button
        v-if="showSaveButton"
        type="flat"
        size="large"
        icon-pack="feather"
        icon="icon-save"
        @click.prevent="$emit('save')"
      />
    </transition>
    <vs-button
      type="flat"
      size="large"
      icon-pack="feather"
      icon="icon-trash-2"
      @click.prevent="$emit('delete')"
    />
  </div>
</template>

<script>
export default {
  props: {
    showSaveButton: {
      type: Boolean,
      required: true
    }
  }
}
</script>
